import { Box, BoxProps, Text } from "@chakra-ui/react";
import React from "react";

type TAccountTypeCardProps = BoxProps & {
  value: string;
  label: string;
  description: string;
  icon: React.ReactNode;
  isSelected?: boolean;
  onSelect?: (value: string) => void;
};

export const AccountTypeCard: React.FC<TAccountTypeCardProps> = (props) => {
  const {
    value,
    label,
    description,
    icon,
    isSelected = false,
    onSelect,
    ...rest
  } = props;

  return (
    <Box
      as="button"
      type="button"
      onClick={() => onSelect?.(value)}
      display="flex"
      flexDirection="row"
      alignItems="center"
      padding="5px 15px"
      gap="15px"
      bg={isSelected ? "purple.100" : "white"}
      border="1px solid"
      borderColor={isSelected ? "purple.600" : "white"}
      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)"
      borderRadius="8px"
      w="full"
      textAlign="left"
      transition="all 0.2s"
      _hover={{
        borderColor: isSelected ? "purple.600" : "purple.200",
        boxShadow:
          "0px 2px 4px rgba(0, 0, 0, 0.1), 0px 2px 3px rgba(0, 0, 0, 0.06)",
      }}
      _focus={{
        outline: "none",
        borderColor: "purple.600",
        boxShadow: "0px 0px 0px 3px rgba(99, 102, 241, 0.1)",
      }}
      {...rest}>
      <Box color={isSelected ? "black" : "gray.500"}>{icon}</Box>
      <Box flex={1} py={3}>
        <Text fontWeight="bold" fontSize="md" m={0}>
          {label}
        </Text>
        <Text fontSize="sm" lineHeight="1.4">
          {description}
        </Text>
      </Box>
    </Box>
  );
};
